export default __webpack_public_path__ + "static/media/work-1right-2.3c7e8820.png";